import { useEffect } from "react";
import { Card, TextInput, Button, Select, Label, ToggleSwitch } from "flowbite-react";
import useUsers from "../hooks/useUsers";
import { useNavigate, useParams } from "react-router-dom";
import useProfiles from "../hooks/useProfiles";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { userSchema } from "../schemas/user.schema";
import { toast } from "react-toastify";
import { routes } from "../routes";
import { useAuth } from "../context/authContext";

const UserDetailsScreen = () => {
    const { permissions } = useAuth()

    const canCreate = permissions.find(item => item.slug === 'crear-usuarios')
    const canEdit = permissions.find(item => item.slug === 'editar-usuarios')

    const { id } = useParams()
    const { user, findUser, createUser, updateUser, loading } = useUsers()
    const { profiles, fetchProfiles } = useProfiles()

    const { register, handleSubmit, setValue, getValues, watch, formState: { errors } } = useForm({
        resolver: yupResolver(userSchema),
    });

    const navigate = useNavigate();

    watch("active")

    useEffect(() => {
        (async () => {
            await fetchProfiles({
                page: 1,
                limit: 9999
            });

            if(!id) return

            const itemId = parseInt(id)
            if(!isNaN(itemId)){
                await findUser(itemId)
            }
        })();
        // eslint-disable-next-line
    },[id])

    useEffect(() => {
        if(!user) return;

        setValue("name", user.display_name)
        setValue("email", user.email)
        setValue("profile", user.profile_id)
        setValue("active", user.active)
        // eslint-disable-next-line
    },[user])

    const save = async (data: any) => {
        let info: any = {
            name: data.name,
            email: data.email,
            profile: data.profile,
            active: data.active,
        }

        if(data.password && data.confirmPassword && data.password === data.confirmPassword){
            info.password = data.password
        }

        if(user === null && canCreate){
            const saved = await createUser(info)
            toast(saved ? "Usuario guardado correctamente" : "Ocurrió un error al guardar el usuario", {
                type: saved ? "success": "error"
            });
            navigate(`${routes.DASHBOARD}/${routes.USERS}`, {
                replace: true
            })
            return
        }

        if(user && canEdit){
            const saved = await updateUser(user.id, info)
            toast(saved ? "Usuario guardado correctamente" : "Ocurrió un error al guardar el usuario", {
                type: saved ? "success": "error"
            });
            return
        }

       
    }

    return <div className="m-4">
        <div className="mb-4">
            <div className="flex flex-row justify-between">
                <h1>Detalles de usuario</h1>
                <Button isProcessing={loading} disabled={loading} onClick={handleSubmit(save)}>Guardar usuario</Button>
            </div>
        </div>
        <Card>
            <div className="flex flex-col mb-2">
                <Label className="mb-2">Nombre</Label>
                <TextInput 
                    placeholder="Escriba aquí"
                    {...register("name",{
                        value: user?.display_name || ""
                    })}
                    helperText={errors && errors.name ? errors.name.message : ""}
                    required 
                    color={errors && errors.name ? "failure" : "gray"}
                />
            </div>
            <div className="flex flex-col mb-2">
                <Label className="mb-2">Email</Label>
                <TextInput 
                    placeholder="Escriba aquí"
                    {...register("email",{
                        value: user?.email || ""
                    })}
                    helperText={errors && errors.email ? errors.email.message : ""}
                    required 
                    color={errors && errors.email ? "failure" : "gray"}
                />
            </div>
            <div className="flex flex-col mb-2">
                <Label className="mb-2">Contraseña</Label>
                <TextInput 
                    placeholder="Escriba aquí"
                    {...register("password")}
                    type="password"
                />
            </div>
            <div className="flex flex-col mb-2">
                <Label className="mb-2">Confirme la contraseña</Label>
                <TextInput 
                    placeholder="Escriba aquí"
                    {...register("confirmPassword")}
                    helperText={errors && errors.confirmPassword ? errors.confirmPassword.message : ""}
                    color={errors && errors.confirmPassword ? "failure" : "gray"}
                    type="password"
                />
            </div>
            <div className="flex flex-col">
                <Label htmlFor="profile" className="mb-2">Perfíl</Label>
                <Select 
                    id="profile"
                    required 
                    {...register("profile",{
                        value: user?.profile_id || 0
                    })}
                    helperText={errors && errors.profile ? errors.profile.message : ""}
                    color={errors && errors.profile ? "failure" : "gray"}    
                >
                    <option value="-1">- Elija una opción -</option>
                    {profiles && profiles.map((item) => <option key={item.id} value={item.id}>{item.title}</option>)}
                </Select>   
            </div>
            <div className="mt-2">
                <ToggleSwitch  checked={getValues("active") === 1} label="¿Activo?" onChange={(e) => setValue("active",e ? 1 : 0)} />
            </div>
        </Card>

        </div>
}


export default UserDetailsScreen